var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty flex-v"},[_c('img',{staticClass:"img",attrs:{"src":require("images/空值@2x.png"),"alt":""}}),(_vm.title)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.tips)?_c('span',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }